import { LibraryVM } from '../view-models/library.viewModel';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import { Row, TableList } from './TableList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '@mui/material';
import { FoldersGalleryView } from './FoldersGalleryView';
import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import { faSquare } from '@fortawesome/pro-light-svg-icons';
import { ListsWrapper } from './ListsWrapper';
import { FilesGalleryView } from './FilesGalleryView';
import { useRef } from 'react';

export const LibraryContent = (p: LibraryVM) => {
  const foldersGalleryRef = useRef(null);
  const filesGalleryRef = useRef(null);

  return (
    <>
      <ListsWrapper
        type="folders"
        schema={p.folders.schema}
        listSelection={p.folders.listSelection}
        showGalleryView={p.showGalleryView}
        rows={p.folders.rows}
        searchText={p.searchText}
      >
        {p.showGalleryView ? (
          <FoldersGalleryView
            {...p.folders.gallery}
            loading={p.showLoader}
            filesGalleryRef={filesGalleryRef}
            foldersGalleryRef={foldersGalleryRef}
          />
        ) : p.showLoader ? (
          <TableLoader rows={5} height={130} />
        ) : (
          <div className="flex flex-col gap-2">
            {p.folders.rows.map((v) => (
              <div key={v.id} className="flex">
                <Checkbox
                  checkedIcon={
                    <FontAwesomeIcon icon={faSquareCheck} className="w-5 h-5" />
                  }
                  icon={
                    <FontAwesomeIcon
                      icon={faSquare}
                      className="w-5 h-5 text-black"
                    />
                  }
                  checked={p.folders.listSelection.selectedIds.includes(
                    Number(v.id),
                  )}
                  onChange={() =>
                    p.folders.listSelection?.onSelect(Number(v.id))
                  }
                />
                <Row
                  key={v.id}
                  cells={v.cells}
                  schema={p.folders.schema}
                  itemHeight={44}
                  itemGap={8}
                  rowClassName="p-0 px-4 m-0"
                />
              </div>
            ))}
          </div>
        )}
      </ListsWrapper>
      <ListsWrapper
        type="files"
        schema={p.files.schema}
        listSelection={p.files.listSelection}
        showGalleryView={p.showGalleryView}
        rows={p.files.rows}
        searchText={p.searchText}
      >
        {p.showGalleryView ? (
          <FilesGalleryView
            {...p.files.gallery}
            loading={p.showLoader}
            filesGalleryRef={filesGalleryRef}
            foldersGalleryRef={foldersGalleryRef}
          />
        ) : p.showLoader ? (
          <TableLoader rows={5} height={130} />
        ) : (
          <TableList
            rows={p.files.rows}
            schema={p.files.schema}
            itemHeight={84}
            itemGap={16}
            hideHeader={true}
            rowClassName="min-w-[700px] md:min-w-[800px]"
            withSelection={p.files.listSelection}
            loading={p.showLoader}
          />
        )}
      </ListsWrapper>
    </>
  );
};
